const capitalize = function (value) {
  //Unicode编码转换用户名中文
  if (!value) return ''
  var v=value.replace(/\\/g,"%");
  var str
  str = unescape(v);
  return str;
}
const splitTime = (endTime) => {
  var thisTime = null
  if (endTime) {
    thisTime = endTime.split('T')[0]
  }
  return thisTime
}
const strToArray = (string) => {
  let newArray
  if(typeof string !== "string"){
    string = JSON.stringify(string)
  }
  newArray = string.replace(/"/g, '').replace(/'/g, '').replace('[', '').replace(']', '').replace(/,/g, '')
  return newArray
}
const peopleSplit= (string) => {
  let newString
  newString = string.substring(0, 1)
  return newString
}

const splitText= (string) => {
  let newString
  newString = string.substring(0, 60) + '...'
  return newString
}

export default{
  capitalize,
  splitTime,
  strToArray,
  peopleSplit,
  splitText,
}



// WEBPACK FOOTER //
// ./src/config/filters.js